import { Modal, Button, FormGroup, Form } from 'react-bootstrap';

export class ModalForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: false,
    };
    this.enforceLength = this.enforceLength.bind(this);
  }

  componentDidMount() {
    this.setState({
      showModal: this.props.showModal,
    });
  }

  handleHide() {
    if (this.props.ShowContent === false) {
      this.setState({ showModal: false });
    } else {
      this.setState({ showModal: false });
      this.redirectLandingModal();
    }
    this.props.handleHideModal && this.props.handleHideModal('showModalForm');
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  sendData() {
    this.props.UpdateInfoUserEvent();
  }

  redirectLandingModal() {
    // window.location.href =
    //   _spPageContextInfo.siteAbsoluteUrl +
    //   resourcesEncuesta.getResource(
    //     "es",
    //     "nsEncuesta",
    //     "Score.redirectLanding"
    //   );
    this.props.handleVolverA2();
  }

  setValueId(e) {
    if (e.target.value.length >= 6 && this.validateNumbers(e.target.value)) {
      compensar.inputId = true;
    } else {
      compensar.inputId = false;
    }
    this.props.GetInputIdentification(e);
    this.validateBtnModal();
  }

  setValueMail(e) {
    if (this.validateEmail(e.target.value)) {
      compensar.inputMail = true;
    } else {
      compensar.inputMail = false;
    }
    this.validateBtnModal();
    this.props.GetInputEmail(e);
  }

  setValueTel(e) {
    if (e.target.value.length == 10 && this.validateNumbers(e.target.value)) {
      compensar.inputTel = true;
    } else {
      compensar.inputTel = false;
    }
    this.validateBtnModal();
    this.props.GetInputPhone(e);
  }

  validateNumbers(num) {
    var re = /^[0-9]*$/;
    return re.test(num);
  }

  validateBtnModal() {
    // Validación cuando el formulario tiene los campos Teléfono, Email y Nombre activos
    // let valido = compensar.inputTel && compensar.inputId && compensar.inputMail && compensar.inputChecked && compensar.inputSelect
    let valido =
      compensar.inputId && compensar.inputChecked && compensar.inputSelect;
    valido
      ? Array.prototype.slice
          .call(document.querySelectorAll(".send.btn-default.last"))
          .forEach((btn) => {
            btn.disabled = false;
          })
      : Array.prototype.slice
          .call(document.querySelectorAll(".send.btn-default.last"))
          .forEach((btn) => {
            btn.disabled = true;
          });
  }

  enforceLength(evt) {
    this.setState({
      [event.target.getAttribute("data-BackingField")]:
        event.target.value.replace(/\D/, ""),
    });
  }

  validateEmail(email) {
    var re =
      /^(([^<>()\[\]\\.,;:$#&%\s@"]+(\.[^<>()\[\]\\.,;:$#&%\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    return re.test(email);
  }

  render() {
    return (
      <div id="modal-wrap">
        <div className="modal-container">
          <Modal
            show={this.state.showModal}
            container={this.props.container}
            className="modalemail"
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title-lg"
          >
            <Modal.Header>
              <Modal.Title>
                {resourcesEncuesta.getResource(
                  "es",
                  "nsEncuesta",
                  "Modal.title"
                )}
              </Modal.Title>
              <Button
                className=""
                onClick={() => {
                  this.handleHide();
                }}
              >
                <i className="fa fa-times"></i>
              </Button>
            </Modal.Header>
            <Modal.Body>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 modal-error-body">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 right-error-modal">
                  <h4>
                    {resourcesEncuesta.getResource(
                      "es",
                      "nsEncuesta",
                      "Modal.heading"
                    )}
                  </h4>
                  <p>{this.props.MessageModal}</p>
                  {this.props.ShowContent === false ? (
                    <Form horizontal>
                      <FormGroup controlId="formControlsSelect">
                        <div className="form-group">
                          <DropdownButton
                            dropup={false}
                            className="dropdown-custom"
                            bsStyle="inline mt-12"
                            onSelect={this.props.GetInputDropdown}
                            title={
                              this.props.TitleDropdown === ""
                                ? resourcesEncuesta.getResource(
                                    "es",
                                    "nsEncuesta",
                                    "Modal.placeholderDrop"
                                  )
                                : this.props.TitleDropdown
                            }
                            id="first"
                          >
                            {this.props.DataDrowdown.map((item, index) => {
                              return (
                                <MenuItem
                                  eventKey={{
                                    position: index,
                                    name: item.name,
                                    code: item.code,
                                  }}
                                >
                                  {toolsTransacciones.toCapitalize(item.name)}
                                </MenuItem>
                              );
                            })}
                          </DropdownButton>
                        </div>
                        <div className="form-group">
                          <div className="input-group">
                            <div className="input-group-addon">
                              <i className="fa fa-address-card special"></i>
                            </div>
                            <input
                              type="text"
                              data-BackingField="Id"
                              className="form-control"
                              value={this.state.Id}
                              onChange={this.enforceLength}
                              onKeyUp={this.setValueId.bind(this)}
                              id="inputId"
                              maxLength={10}
                              onBlur={this.props.ValidateInfoUserEvent}
                              placeholder={resourcesEncuesta.getResource(
                                "es",
                                "nsEncuesta",
                                "Modal.placeholderId"
                              )}
                            />
                          </div>
                        </div>
                        {
                          // Se remueven los campos Teléfono, Email y Nombre
                          /* <div className="form-group">
                                                        <div className="input-group">
                                                            <div className="input-group-addon"><i className="fa fa-user special"></i></div>
                                                            <input
                                                                type="text"
                                                                disabled={this.props.DisableInputForm}
                                                                className="form-control"
                                                                id="inputName"
                                                                placeholder={resourcesEncuesta.getResource("es", "nsEncuesta", "Modal.placeholderNombre")}
                                                                />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="input-group">
                                                            <div className="input-group-addon"><i className="fa fa-phone special"></i></div>
                                                            <input type="text" disabled={this.props.DisableInputForm} data-BackingField="Tel" value={this.state.Tel} className="form-control" onChange={this.enforceLength} onKeyUp={this.setValueTel.bind(this)} id="inputTel" maxLength={10} placeholder={resourcesEncuesta.getResource("es", "nsEncuesta", "Modal.placeholderNumero")} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="input-group">
                                                            <div className="input-group-addon"><i className="fa fa-envelope-open special"></i></div>
                                                            <input type="text" disabled={this.props.DisableInputForm} className="form-control" onKeyUp={this.setValueMail.bind(this)} id="inputMail" maxLength={50} placeholder={resourcesEncuesta.getResource("es", "nsEncuesta", "Modal.placeholderEmail")} />
                                                        </div>
                                                    </div> */
                        }
                        <div className="checkbox">
                          <div>
                            <input
                              type="checkbox"
                              disabled={this.props.DisableInputForm}
                              id="accept"
                              onChange={this.props.GetInputCheck}
                              className="checkLabel"
                            />
                            <p className="checkText">
                              Autorizo el{" "}
                              <a
                                href={resourcesEncuesta.getResource(
                                  "es",
                                  "nsEncuesta",
                                  "Modal.redirectPdf"
                                )}
                                target="_blank"
                              >
                                tratamiento de mis datos personales
                              </a>
                            </p>
                          </div>
                        </div>
                      </FormGroup>
                    </Form>
                  ) : null}
                </div>
              </div>
              <hr className="line" />
              <div className="inner-Model-buttons">
                {this.props.ShowContent === false ? (
                  <Button
                    className="btn btn-default btn-no btn-right send btn-default last"
                    onClick={this.sendData.bind(this)}
                  >
                    {resourcesEncuesta.getResource(
                      "es",
                      "nsEncuesta",
                      "Modal.aceptar"
                    )}
                  </Button>
                ) : (
                  <Button
                    className="btn btn-default btn-no btn-right send btn-default last"
                    onClick={this.handleHide.bind(this)}
                  >
                    {" "}
                    {resourcesEncuesta.getResource(
                      "es",
                      "nsEncuesta",
                      "Modal.aceptar"
                    )}
                  </Button>
                )}
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

// const Modal = ReactBootstrap.Modal;
// const Button = ReactBootstrap.Button;
// const FormGroup = ReactBootstrap.FormGroup;
// const Col = ReactBootstrap.Col;
// const ControlLabel = ReactBootstrap.ControlLabel;
// const FormControl = ReactBootstrap.FormControl;
// const Form = ReactBootstrap.Form;
const DropdownButton = ReactBootstrap.DropdownButton;
const MenuItem = ReactBootstrap.MenuItem;
